import React, { useEffect, useState } from 'react';
import AxiosClient from '../../assets/AxiosClient';
import { useNavigate, useParams } from 'react-router-dom';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import Loader from '../../assets/tools/Loder/loader';
import { Modal, Button } from 'react-bootstrap'; // Ensure correct import

const User = () => {
    const {SetNotification ,API} =useStateContext () ;
  const [user, setUser] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const { id } = useParams();
    const [activating, setActivating] = useState(false); 
   const [showConfirmModal, setShowConfirmModal] = useState(false); 
    const [actionType, setActionType] = useState(null); 
const navigate = useNavigate() ; 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get(`/Users/show/${id}`);
        if (response.status === 200) {
          console.log(response);
          setUser(response.data.user);
          setIsLoading(false);
        }
      } catch (error) {
        console.log('Error fetching data:', error);
      }
    };

    fetchData();
  }, [id]);


  
  const handelCancel = async()=>{
   
      navigate(-1); 
    
  }
  const handelActivate = async () => {
    setActivating(true);
    try {
        await AxiosClient.put(`/Users/activation/${id}`, { active: !user.active })
            .then((res) => {
                !user.active ? SetNotification("User Activated Successfully!", 'success') : SetNotification("User Deactivated Successfully!", 'warning');
                setUser(res.data.user); 
            });
    } catch (error) {
        SetNotification(error, 'danger');
    }
    setActivating(false); 
};

const handleShowModal = (action) => {
    setActionType(action);
    setShowConfirmModal(true);
};

const handleCloseModal = () => {
    setShowConfirmModal(false);
    setActionType(null);
};

const handleConfirmAction = () => {
    handelActivate();
    handleCloseModal();
};
    
  const handelDelete = async()=>{
    const confirmed = window.confirm('Are you sure you want to delete this user ?');
    if (confirmed) {
      await AxiosClient.delete("Users/" + id ).then(()=>{
        navigate(-1); 

      }).catch((err)=> alert("somthing bad happen")); 

    }
  
}
  return (
    <>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">System User</h4>
        </div>
        {loading ? (
          <Loader label="Loading user details..." />
        ) : (
          <div className="card-body">
            <div className="card-content text-dark">
              <div className="row">
                <div className="col-6">
                  <p className="card-text">
                    <span className="text-bold">English Name:</span>{' '}
                    {user.first_name} {user.last_name}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Email:</span> {user.email}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Position:</span> {user.position}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Gender:</span> {user.gender}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Address:</span> {user.country} {user.city}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Organization:</span> {user.organization}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Nationality:</span>{user.nationality}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Phone:</span> {user.phone}
                  </p>
                  <p className="card-text">
                    <span className="text-bold">Role:</span> {user.role}
                  </p>
                  <p className="card-text">
   
                  </p>
                </div>
                <div className="col-6 text-end">
                  <img
                  src={`${API}${user.image}`}
                    className="w-25 border"
                    alt="Profile"
                  />
                </div>
              </div>
           
              <button className='btn btn-dark m-2' onClick={handelCancel}>
                cancel
              </button>
              <button className='btn btn-danger m-2' onClick={handelDelete}>
              Delete
              </button>
              {!activating ? (
                            <button
                                className={`btn m-2 ${user.active ? 'btn-danger' : 'btn-success'}`}
                                onClick={() => handleShowModal(user.active ? 'deactivate' : 'activate')}
                            >
                                {user.active ? 'Deactivate' : 'Activate'}
                            </button>
                        ) : (
                            <span className="text-success">Processing...</span>
                        )}
            </div>
          </div>
        )}
      </div>
      
            {/* Confirmation Modal */}
            <Modal show={showConfirmModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Action</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {actionType === 'activate'
                        ? 'Are you sure you want to activate this user?'
                        : 'Are you sure you want to deactivate this user?'}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Cancel</Button>
                    <Button variant="primary" onClick={handleConfirmAction}>Confirm</Button>
                </Modal.Footer>
            </Modal>
    </>
  );
};

export default User;